import React from 'react';
import { mapScoreToBgColor } from '../../../../common/utils';
import { ScoreContainer } from './styled';

export const Score = ({ score }: { score: number }) => (
	<ScoreContainer backgroundColor={mapScoreToBgColor(score)}>{score}</ScoreContainer>
);
